<template>
  <div>
    <section class="page_box">
      <img :src="bannerImgUrl" alt="" />
    </section>
    <div id="bigBox">
      <section class="page_nav" :class="{ fixed: navFixed }">
        <ul>
          <li
            :class="{ active: activeNav === 0 }"
            @click="navClick(0, 'business_box')"
          >
            业务介绍
          </li>
          <li
            :class="{ active: activeNav === 1 }"
            @click="navClick(1, 'service_box')"
          >
            服务范围
          </li>
          <li
            :class="{ active: activeNav === 2 }"
            @click="navClick(2, 'core_box')"
          >
            核心能力
          </li>
          <li
            :class="{ active: activeNav === 3 }"
            @click="navClick(3, 'feature_box')"
          >
            优势特点
          </li>
        </ul>
      </section>
      <section class="business_box module_box" id="business_box">
        <h1 class="main_title">业务介绍</h1>
        <div class="business_content sub_module_box">
          <div class="business_desc">
            <h2>河南省润信数字智能科技有限公司</h2>
            <p>
              河南省润信数字智能科技有限公司，成立于 2020 年，是阿里巴巴 &
              钉钉深度战略合作的一站式企业数智化解决方案专家，也是国内领先的数智化企业运营服务商。
            </p>
            <p>
              公司以「AI+123」为核心战略，锚定「企业数智化经营管理」核心主业，以全域电商、互联网新媒体为两大增长引擎，辅以全流程落地、全渠道覆盖、全周期赋能三大保障，打造「企业数智化
              AI
              经营管理核心系统」，为政府、企业、教育、医疗等全行业客户，提供从数智化转型规划、系统搭建、软硬件集成到
              AI 赋能、培训落地的全链路一站式服务，最终帮助企业实现「数智化 +
              AI」升级，达成降本增效、经营提效、可持续增长的核心目标，践行「数智化
              + AI 让企业经营更轻松」的企业使命。
            </p>
          </div>
          <img :src="$utils.formatImgUrl('businessJieshao.png')" alt="" />
        </div>
      </section>

      <section class="service_box module_box" id="service_box">
        <h1 class="main_title">服务范围</h1>
        <ul class="service_content sub_module_box">
          <li class="service_item">
            <img :src="$utils.formatImgUrl('businessImg11.png')" alt="" />
            <div class="service_item_desc">
              <h2>组织数智化</h2>
              <p>
                智能人事、智能协同、智能办公、企业文化建设，覆盖人、事、财、物、法全流程
              </p>
              <div>
                提升办公效率&nbsp;&nbsp;|&nbsp;&nbsp;灵活多端&nbsp;&nbsp;|&nbsp;&nbsp;操作简单
              </div>
            </div>
          </li>
          <li class="service_item">
            <img :src="$utils.formatImgUrl('businessImg12.png')" alt="" />
            <div class="service_item_desc">
              <h2>业务数智化</h2>
              <p>
                项目管理、生产、销售、供应链、售后全链路，集成ERP、MES、CRM、SCM
                等专业系统
              </p>
              <div>
                提升办公效率&nbsp;&nbsp;|&nbsp;&nbsp;灵活多端&nbsp;&nbsp;|&nbsp;&nbsp;操作简单
              </div>
            </div>
          </li>
          <li class="service_item">
            <img :src="$utils.formatImgUrl('businessImg10.png')" alt="" />
            <div class="service_item_desc">
              <h2>AI 智能决策</h2>
              <p>财务管理、智能数据报表、业务智能决策与风险控制</p>
              <div>
                提升办公效率&nbsp;&nbsp;|&nbsp;&nbsp;灵活多端&nbsp;&nbsp;|&nbsp;&nbsp;操作简单
              </div>
            </div>
          </li>
          <li class="service_item">
            <img :src="$utils.formatImgUrl('businessImg13.png')" alt="" />
            <div class="service_item_desc">
              <h2>配套服务</h2>
              <p>
                数智化系统集成、智能办公设备采购 / 安装 /
                维护、全域电商、互联网新媒体运营、培训落地
              </p>
              <div>
                提升办公效率&nbsp;&nbsp;|&nbsp;&nbsp;灵活多端&nbsp;&nbsp;|&nbsp;&nbsp;操作简单
              </div>
            </div>
          </li>
        </ul>
      </section>

      <section class="core_box module_box" id="core_box">
        <h1 class="main_title">核心能力</h1>
        <div class="core_content sub_module_box">
          <ul class="core_content_top">
            <li class="core_top_item">
              <img src="../assets/img/businessIcon1.png" alt="" />
              <h2>全面覆盖</h2>
              <p>全方位解决方案，满足各种需求</p>
            </li>
            <li class="core_top_item">
              <img src="../assets/img/businessIcon2.png" alt="" />
              <h2>协同高效</h2>
              <p>各部分协同工作，整体高效</p>
            </li>
            <li class="core_top_item">
              <img src="../assets/img/businessIcon3.png" alt="" />
              <h2>创新驱动</h2>
              <p>不断研发新方案，满足市场变化</p>
            </li>
            <li class="core_top_item">
              <img src="../assets/img/businessIcon4.png" alt="" />
              <h2>共赢发展</h2>
              <p>与合作伙伴共同发展，创造更多价值</p>
            </li>
          </ul>
          <div class="core_content_bottom">
            <img :src="$utils.formatImgUrl('businessCoreImg.png')" alt="" />
            <ul class="core_bottom_list">
              <li class="core_bottom_item">
                <div>
                  <h2>全链路数智化系统能力</h2>
                  <p>
                    打造企业数智化 AI
                    经营管理核心系统，实现企业全环节、全资源、全信息
                    的数智化整合，达成流程标准化、数据结构化、系统智能化、部门一体化、
                    经营可视化
                  </p>
                </div>
              </li>
              <li class="core_bottom_item">
                <div>
                  <h2>生态与技术能力</h2>
                  <p>
                    深度绑定阿里巴巴 & 钉钉生态，依托低代码搭建、3100+API
                    接口、连接 器平台等技术，实现系统定制开发与集成
                  </p>
                </div>
              </li>
              <li class="core_bottom_item">
                <div>
                  <h2>一站式落地能力</h2>
                  <p>
                    提供从系统规划、软硬件部署、定制开发、平台集成到 AI
                    技术研发、培 训落地的全流程服务
                  </p>
                </div>
              </li>
              <li class="core_bottom_item">
                <div>
                  <h2>AI 赋能能力</h2>
                  <p>
                    以 AI 技术贯穿全链路，打造 “AI+123” 业务框架，为企业提供 AI
                    智能 决策与数智化增长方案
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section class="feature_box module_box" id="feature_box">
        <h1 class="main_title">优势特点</h1>
        <ul class="feature_content sub_module_box">
          <li class="feature_item">
            <img :src="$utils.formatImgUrl('featureImg1.png')" alt="" />
            <div class="feature_item_desc">
              <div class="feature_item_text">
                <h5>生态优势</h5>
                <p>
                  阿里巴巴 & 钉钉深度合作伙伴，依托头部生态技术，方案成熟可落地
                </p>
              </div>
            </div>
          </li>
          <li class="feature_item">
            <img :src="$utils.formatImgUrl('featureImg2.png')" alt="" />
            <div class="feature_item_desc">
              <div class="feature_item_text">
                <h5>战略优势</h5>
                <p>
                  以 “AI+123” 为核心，构建 “数智化经营 + 全域电商 + 新媒体”
                  三维增长体系，AI 贯穿全链路
                </p>
              </div>
            </div>
          </li>
          <li class="feature_item">
            <img :src="$utils.formatImgUrl('featureImg3.png')" alt="" />
            <div class="feature_item_desc">
              <div class="feature_item_text">
                <h5>服务优势</h5>
                <p>
                  一站式全流程服务，从软硬件到培训落地全周期赋能，适配多行业需求
                </p>
              </div>
            </div>
          </li>
          <li class="feature_item">
            <img :src="$utils.formatImgUrl('featureImg4.png')" alt="" />
            <div class="feature_item_desc">
              <div class="feature_item_text">
                <h5>理念优势</h5>
                <p>
                  立足 “高技术、高质量、高效率、高效益”
                  方针，以“诚信、坚韧、创新、效率” 为核心价值观，以 “数智化 +
                  AI让企业经营更轻松” 为使命，专业靠谱
                </p>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import { getBannerConfigApi } from "@/apis/index.js";
export default {
  components: {},
  name: "Business",
  data() {
    return {
      activeNav: 0,
      navFixed: false,
      navTop: 0,
      bannerImgUrl: "",
    };
  },
  created() {
    this.getBanner();
  },
  beforeMount() {
    this.bannerImgUrl = JSON.parse(
      localStorage.getItem("imgUrlList"),
    ).web_business[0].image;
  },
  mounted() {
    // 添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll);

    // 获取page_nav元素的初始位置，确保DOM完全渲染后再获取
    setTimeout(() => {
      const navElement = document.querySelector(".page_nav");
      if (navElement) {
        this.navTop = navElement.offsetTop;
        // 页面刷新后检查滚动位置，更新导航栏状态
        this.handleScroll();
      }
    }, 100);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 获取轮播图配置
    async getBanner() {
      const res = await getBannerConfigApi({ type: "web_business" });
      if (res.code === 200) {
        this.bannerImgUrl = res.result[0].image;
      } else {
        this.$message.error(res.msg);
      }
    },
    navClick(index, targetId) {
      // 更新激活状态
      this.activeNav = index;
      // 标记正在滚动，防止滚动事件触发
      this.isScrolling = true;
      // 滚动到对应模块
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        // 计算滚动位置，考虑固定导航栏的高度
        const navHeight = 90; // 顶部导航栏高度
        const pageNavHeight = 80; // page_nav高度
        const rect = targetElement.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop - navHeight - pageNavHeight; // 20为额外间距

        // 平滑滚动到指定位置
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });

        // 滚动结束后重置标记
        setTimeout(() => {
          this.isScrolling = false;
        }, 1000); // 1秒后滚动应该完成
      }
    },
    handleScroll() {
      // 获取滚动位置
      const scrollTop = window.scrollY;

      // 只有当navTop被正确设置后才进行导航栏状态判断
      if (this.navTop > 0) {
        // 处理page_nav固定定位
        if (scrollTop >= this.navTop - 90) {
          // 90是顶部导航栏的高度
          this.navFixed = true;
        } else {
          this.navFixed = false;
        }

        // 处理顶部导航栏显示/隐藏
        const myNav = document.querySelector(".my_nav");
        if (myNav) {
          if (this.navFixed) {
            myNav.style.opacity = "0";
            myNav.style.transform = "translateY(-100%)";
          } else {
            myNav.style.opacity = "1";
            myNav.style.transform = "translateY(0)";
          }
        }
      }

      // 检测当前滚动位置对应的模块，更新导航激活状态
      if (!this.isScrolling) {
        const modules = [
          { id: "business_box", index: 0 },
          { id: "service_box", index: 1 },
          { id: "core_box", index: 2 },
          { id: "feature_box", index: 3 },
        ];

        const navHeight = 90; // 顶部导航栏高度
        const pageNavHeight = 80; // page_nav高度
        const offset = navHeight + pageNavHeight + 20; // 偏移量

        for (const module of modules) {
          const element = document.getElementById(module.id);
          if (element) {
            const rect = element.getBoundingClientRect();
            // 当模块顶部进入可视区域时，更新激活状态
            if (rect.top <= offset && rect.bottom >= offset) {
              this.activeNav = module.index;
              break;
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.business_box,
.service_box,
.core_box,
.feature_box {
  width: 100%;
  padding: 0 8%;
  box-sizing: border-box;
}

.business_content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 21.625rem;

  .business_desc {
    text-align: left;
    width: 48%;

    > h2 {
      font-size: 1.5rem;
    }

    > p {
      width: 100%;
      text-indent: 2em;
      font-size: 1rem;
      font-weight: 400;
      line-height: 26px;
      margin-top: 24px;
    }
  }
  > img {
    height: 320px;
  }
}

.service_content,
.feature_content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > li:nth-child(3),
  > li:nth-child(4) {
    margin-top: 40px;
  }
  .service_item,
  .feature_item {
    width: 48%;
    height: 460px;
    border-radius: 10px;
    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    text-align: left;
    position: relative;

    > img {
      width: 100%;
    }

    .service_item_desc,
    .feature_item_desc {
      width: 98%;
      height: 180px;
      opacity: 1;
      border-radius: 10px 10px 0px 0px;
      background: rgba(255, 255, 255, 1);
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      padding: 1.25rem;
      box-sizing: border-box;
    }
  }
}
.feature_item_desc {
  display: flex;
  align-items: center;
  justify-content: space-around;

  > img {
    width: 50px;
  }
  .feature_item_text {
    width: 90%;

    > h5 {
      font-size: 1.125rem;
      font-weight: 600;
      line-height: 24px;
      color: rgba(29, 34, 42, 1);
    }
    > p {
      width: 100%;
      margin-top: 16px;
      font-size: 0.875rem;
      line-height: 24px;
      color: rgba(153, 153, 153, 1);
    }
  }
}
.service_item_desc {
  > h2 {
    font-size: 1.5rem;
  }
  > p {
    font-size: 0.875rem;
    margin: 14px 0 30px;
  }
  > div {
    font-size: 0.875rem;
    color: rgba(153, 153, 153, 1);
  }
}

.core_content_top {
  width: 100%;
  display: flex;
  justify-content: space-evenly;

  .core_top_item {
    width: 22%;
    text-align: center;

    > img {
      width: 60px;
      height: 60px;
      border-radius: 10px;
    }
    > h2 {
      font-size: 1.125rem;
      font-weight: 600;
      margin: 20px auto 10px;
    }
    > p {
      font-size: 0.875rem;
      color: rgba(153, 153, 153, 1);
    }
  }
}
.core_content_bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 400px;
  margin-top: 50px;

  > img {
    width: 50%;
  }

  .core_bottom_list {
    width: 46%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .core_bottom_item {
      display: flex;
      align-items: center;
      > img {
        width: 50px;
        height: 50px;
      }

      > div {
        margin-left: 20px;
        text-align: left;
        > h2 {
          font-size: 1.125rem;
          font-weight: 600;
          color: rgba(9, 15, 25, 1);
        }

        > p {
          // width: 462px;
          font-size: 0.875rem;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin-top: 10px;
        }
      }
    }
  }
}

.page_nav {
  width: 100%;
  position: relative;
  transition: all 0.3s ease;
  > ul {
    width: 804px;
    height: 60px;
    border-radius: 50px;
    background: #fff;
    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);

    > li {
      width: 190px;
      line-height: 50px;
      opacity: 1;
      border-radius: 25px;
      box-sizing: border-box;
      font-size: 1.125rem;
      font-weight: 400;
      cursor: pointer;
    }
    > li.active {
      background: rgba(228, 245, 255, 1);
      color: rgba(7, 70, 255, 1);
      border: 1px solid rgba(228, 245, 255, 1);
    }
  }
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    padding: 0.625rem 0;
    > ul {
      position: relative;
      bottom: auto;
      left: auto;
      transform: none;
    }
  }
}
</style>
